<template>
  <div class="ContentHomeTrackrecord home-trackrecord">
    <div class="page-container home-trackrecord__container">
      <h4 class="home-trackrecord__title">
        Investors from every state are building their land portfolios with AcreTrader:
      </h4>
      <InvestmentsTrackrecord />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import InvestmentsTrackrecord from 'Components/InvestmentsTrackrecord/InvestmentsTrackrecord.vue';

export default defineComponent({
  name: 'ContentHomeTrackrecord',
  components: {
    InvestmentsTrackrecord,
  },
});
</script>

<style lang="sass" scoped>
@import '~Styles/_variables'
.home-trackrecord
  padding: 110px 0
  background: linear-gradient(180deg, rgba(63, 166, 117, 0.2) -75.09%, rgba(46, 122, 86, 0.2) 100%)
  @media screen and (max-width: 767px)
    padding: 100px 0
  &__container
    display: flex
    flex-direction: column
    text-align: center
  &__title
    margin-bottom: 30px
    @media screen and (max-width: 767px)
      margin-bottom: 20px
</style>
